import React from "react";
import { connect } from 'react-redux'
import cognitoUtils from '../../lib/cognito'
const divStyle = {
    paddingTop: '8px'
};
class Login extends React.Component {
    constructor(props) {
        super(props)

    }

    componentDidMount() {
    }
    onSignOut = (e) => {
        e.preventDefault()
        cognitoUtils.signOutCognitoSession()
    }
    render() {
        return (
            <>
                {this.props.session.isLoggedIn ? (
                    <li style={divStyle} ><a href="#" onClick={this.onSignOut}>Sign out({this.props.session.session.user.email})</a></li>
                ) : (

                        <li className="nav-link" style={divStyle} ><a  style={{ color: '#fff' }} href={cognitoUtils.getCognitoSignInUri()}><p>Sign in</p></a></li>

                    )}
            </>
        );
    }

}

const mapStateToProps = state => {
    return { session: state.session }
}

export default connect(mapStateToProps)(Login);